import { Grid, Typography } from "@mui/material";
import { PipelineScheduleStatus } from "../../../modules/operational/models/GetPipelineSchedulesDTO";
import StatusTextTag from "../../StatusTextTag/StatusTextTag";

interface Props {
  title: string;
  subtitle?: string;
  status?: PipelineScheduleStatus;
}

export const DataField: React.FC<Props> = ({ title, subtitle, status }) => (
  <Grid container direction="column">
    <Typography
      color="shadesOfDark.dark"
      sx={{ fontWeight: 700, fontSize: "1.5rem" }}
    >
      {title}
    </Typography>

    {subtitle ? (
      <Typography color="shadesOfDark.dark">{subtitle}</Typography>
    ) : (
      status && <StatusTextTag value={status} />
    )}
  </Grid>
);
